import type {ReactElement} from 'react';
import React from 'react';
import {ContextualMenuFontButton} from '@Components/contextual-menu/components/contextual-menu-font-button';
import {isFontSupported} from '@Libraries/font-library';
import {BasePosterEditingFontOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-poster-editing-font-option';
import {useAppSelector} from '@/hooks';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetKeyFromTextStylesActiveItem} from '@Hooks/poster-editor/useGetKeyFromTextStylesActiveItem';

interface ItemFontOptionProps {
  onClickFontButton(): void;
}

export function ItemFontOption({...props}: ItemFontOptionProps): ReactElement<any> {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const areFontsLoading = useAppSelector((state) => {
    return state.fontSelector.areFontsLoading;
  });
  const fontFamily = useGetKeyFromTextStylesActiveItem('fontFamily');

  if (!activeItem || (activeItem && !('textStyles' in activeItem)) || fontFamily === undefined) {
    throw new Error('Item does not have text styles attribute');
  }

  const onClickHandler = (): void => {
    props.onClickFontButton();
  };

  return (
    <BasePosterEditingFontOption>
      <ContextualMenuFontButton
        id="item-font-option"
        label={window.i18next.t('pmwjs_font')}
        selectedFontFamily={fontFamily}
        onClickFontButton={onClickHandler}
        isFontSuppported={isFontSupported(fontFamily) && !areFontsLoading}
      />
    </BasePosterEditingFontOption>
  );
}
